import {
    NEW_EVOLUCAO_ANIMAL_SUCCESS,
    TABLE_EVOLUCAO_ANIMAL_PENDING,
    TABLE_EVOLUCAO_ANIMAL_SUCCESS,
    TABLE_EVOLUCAO_ANIMAL_FAILURE,
    LIST_EVOLUCAO_ANIMAL_PENDING,
    LIST_EVOLUCAO_ANIMAL_SUCCESS,
    LIST_EVOLUCAO_ANIMAL_FAILURE,
    FIND_EVOLUCAO_ANIMAL_PENDING,
    FIND_EVOLUCAO_ANIMAL_SUCCESS,
    FIND_EVOLUCAO_ANIMAL_FAILURE,
    DELETE_EVOLUCAO_ANIMAL_PENDING,
    DELETE_EVOLUCAO_ANIMAL_SUCCESS,
    DELETE_EVOLUCAO_ANIMAL_FAILURE,
    CREATE_EVOLUCAO_ANIMAL_PENDING,
    CREATE_EVOLUCAO_ANIMAL_SUCCESS,
    CREATE_EVOLUCAO_ANIMAL_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function evolucaoAnimalReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_EVOLUCAO_ANIMAL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_EVOLUCAO_ANIMAL_PENDING:
        case FIND_EVOLUCAO_ANIMAL_PENDING:
        case DELETE_EVOLUCAO_ANIMAL_PENDING:
        case CREATE_EVOLUCAO_ANIMAL_PENDING:
        case TABLE_EVOLUCAO_ANIMAL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_EVOLUCAO_ANIMAL_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_EVOLUCAO_ANIMAL_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_EVOLUCAO_ANIMAL_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_EVOLUCAO_ANIMAL_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_EVOLUCAO_ANIMAL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_EVOLUCAO_ANIMAL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_EVOLUCAO_ANIMAL_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_EVOLUCAO_ANIMAL_SUCCESS:
        case CREATE_EVOLUCAO_ANIMAL_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_EVOLUCAO_ANIMAL_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { evolucaoAnimalReducer };